import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=5a898bd6&scoped=true&"
import script from "./Agreement.vue?vue&type=script&lang=js&"
export * from "./Agreement.vue?vue&type=script&lang=js&"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=5a898bd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a898bd6",
  null
  
)

component.options.__file = "Agreement.vue"
export default component.exports